/**
 * Navega para a tela Saídas com filtro já aplicado (empresa + nº da saída).
 * Consumido em `js/cruds/outputs.js` na abertura da tela.
 */

const STORAGE_KEY = 'sial.navigate.outputs.filter';

/**
 * @param {{ companyId: string, outputId: number|string }} opts
 */
export function openOutputsFiltered({ companyId, outputId })
{
	const cid = String(companyId || '').trim();
	const oid = String(outputId ?? '').trim();
	if (!cid || !oid)
		return;
	const filter = {
		'field-0': 'company_id',
		'operator-0': 'eq',
		'value-0': cid,
		'field-1': 'id',
		'operator-1': 'eq',
		'value-1': oid,
	};
	try {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(filter));
	} catch {
		/* ignore */
	}
	location.hash = '#outputs';
}

/**
 * @returns {object|null}
 */
export function consumeOutputsPendingFilter()
{
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY);
		if (!raw) return null;
		sessionStorage.removeItem(STORAGE_KEY);
		const data = JSON.parse(raw);
		return data && typeof data === 'object' ? data : null;
	} catch {
		try { sessionStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
		return null;
	}
}
